import { useState } from 'react'
import { ErkundenPage } from './pages/ErkundenPage'
import { UebenPage } from './pages/UebenPage'
import type { Mode } from './types'

const MODUS_LABELS: Record<Mode, string> = {
  'erkunden': 'Erkunden',
  'ueben-mit-hilfe': 'Üben mit Hilfe',
  'ueben-ohne-hilfe': 'Üben ohne Hilfe',
}

export function App() {
  const [modus, setModus] = useState<Mode>('erkunden')
  return (
    <div className="app-wrapper">
      <nav className="modus-nav">
        <h1 className="app-titel">Xalento Klaviermodul — Quintenzirkel</h1>
        <div className="modus-buttons">
          {(Object.keys(MODUS_LABELS) as Mode[]).map(m => (
            <button
              key={m}
              className={modus === m ? 'aktiv' : ''}
              onClick={() => setModus(m)}
            >
              {MODUS_LABELS[m]}
            </button>
          ))}
        </div>
      </nav>
      <main>
        {modus === 'erkunden'
          ? <ErkundenPage />
          : <UebenPage modus={modus} />}
      </main>
      <footer className="app-fuss">
        <p>Phase 1 — Quintenzirkel + Vorzeichen + Quint-Beziehungen.
        FSRS-Karten lokal in IndexedDB (<code>xalento-klaviermodul</code>).</p>
      </footer>
    </div>
  )
}
